import React, {Component} from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TextField from '@mui/material/TextField'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'
import { Alert, AlertTitle, Collapse, Grid, Paper, Snackbar } from '@mui/material'

const {DateTime} = require('luxon')
const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class EventosCajeroPage extends Component {

  constructor() {
    super()

    var fechaInicioTemp = DateTime.local().set({hour: 0, minute: 0, second: 0})
    var fechaFinTemp = DateTime.local().set({hour: 23, minute: 59, second: 59})

    this.state = {
      acciones: [
        { id: 80100, descripcion: 'TRANS_INICIO' },
        { id: 80102, descripcion: 'TRANS_LOGIN' },
        { id: 80500, descripcion: 'VACIAR_BOVEDA' },
        { id: 90020, descripcion: 'BOVEDA_ABIERTA' },
        { id: 90021, descripcion: 'BOVEDA_CERRADA' },
      ],
      timeline: [],
      cajeros: [],
      filtroFechaInicio: fechaInicioTemp,
      filtroFechaFin: fechaFinTemp,
      mostrarAlerta: false,
      mensajeAlerta: '',
      severidadAlerta: 'info'
    }

    this.filtroFechaInicio = ""
    this.filtroFechaFin = ""

    this.cmbEstados = React.createRef()
    this.cmbCajeros = React.createRef()
    this.btnBucarClick = this.btnBucarClick.bind(this)
    this.exportExcel = this.exportExcel.bind(this)
  }

  handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ mostrarAlerta: false })
  }

  fechaFiltroChanged(origen, date) {
    if (date == null) return

    var formatoFechaInicio = "yyyy-LL-dd HH:mm:00"
    var formatoFechaFin    = "yyyy-LL-dd HH:mm:59"

    switch (origen) {
      case 'inicio':
        this.setState({ filtroFechaInicio: date })
        this.filtroFechaInicio = date.toFormat(formatoFechaInicio)
        break
      case 'fin':
        this.setState({ filtroFechaFin: date })
        this.filtroFechaFin = date.toFormat(formatoFechaFin)
        break
      default:
    }
  }

  btnBucarClick() {
    this.queryBoveda()
  }

  componentDidMount() {
    this.queryCajeros()
    this.queryBoveda()
  }

  queryCajeros() {
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/cajerosconsultas/list'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.setState({
          cajeros: [],
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando cajeros',
          severidadAlerta: 'error'
        })
      } else {
        this.setState({ cajeros: data })
      }
    })
  }

  queryBoveda() {
    console.log('Consultando historico boveda...')

    var filtroIdCajero = ''
    var filtroIdEvento = ''

    if (this.cmbCajeros.current.value !== 0) {
      filtroIdCajero = this.cmbCajeros.current.value
    }

    if (this.cmbEstados.current.value !== 0) {
      filtroIdEvento = this.cmbEstados.current.value
    }

    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
        filtro_id_cajero:    filtroIdCajero,
        filtro_id_evento:    filtroIdEvento,
        filtro_fecha_inicio: this.filtroFechaInicio,
        filtro_fecha_fin:    this.filtroFechaFin
      },
      url: process.env.REACT_APP_URL_BACKEND + '/eventocajeros/listboveda'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.setState({
          timeline: [],
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando historico boveda',
          severidadAlerta: 'error'
        })
      } else {
        // El backend ya devuelve todo ordenado y unificado
        // Solo mapeamos para tener fecha como objeto Date para el sort si fuera necesario
        const timeline = data.map(row => ({
          ...row,
          fechaDate: DateTime.fromFormat(row.fecha, 'dd/MM/yyyy HH:mm:ss').toJSDate()
        }))
        this.setState({ timeline })
      }
    })
  }

  exportExcel = () => {
    const { timeline } = this.state

    if (!timeline.length) {
      this.setState({
        mostrarAlerta: true,
        mensajeAlerta: 'No hay datos para exportar',
        severidadAlerta: 'warning'
      })
      return
    }

    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet("Historico Boveda")

    sheet.columns = [
      { header: 'Fecha',            key: 'fecha',          width: 22 },
      { header: 'Origen',           key: 'tipo_origen',    width: 14 },
      { header: 'Evento',           key: 'nombre_evento',  width: 25 },
      { header: 'Cajero',           key: 'cajero',         width: 20 },
      { header: 'Funcionario',      key: 'funcionario',    width: 30 },
      { header: 'Usuario autorizó', key: 'usuario_autorizo', width: 30 },
      { header: 'Detalle',          key: 'detalle',        width: 40 }
    ]

    timeline.forEach(row => {
      sheet.addRow({
        fecha:           row.fecha,
        tipo_origen:     row.tipo_origen,
        nombre_evento:   row.nombre_evento,
        cajero:          row.cajero         || '',
        funcionario:     row.funcionario    || '',
        usuario_autorizo: row.usuario_autorizo || '',
        detalle:         row.detalle        || ''
      })
    })

    sheet.getRow(1).font = { bold: true }

    workbook.xlsx.writeBuffer().then((data) => {
      FileSaver.saveAs(new Blob([data]), 'Historico_Boveda.xlsx')
      this.setState({
        mostrarAlerta: true,
        mensajeAlerta: 'Archivo Excel generado correctamente',
        severidadAlerta: 'success'
      })
    })
  }

  render() {
    return (
      <Box>
        <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
          Historico Cajero
        </Typography>

        <Paper elevation={16}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                Buscar historico:
              </Typography>

              <Grid container spacing={2}>
                <Grid item container spacing={2}>
                  <Grid item>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                      <DateTimePicker
                          inputFormat="dd/MM/yyyy HH:mm"
                        label="Fecha/Hora inicio"
                        value={this.state.filtroFechaInicio}
                        onChange={date => this.fechaFiltroChanged('inicio', date)}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                      <DateTimePicker
                          inputFormat="dd/MM/yyyy HH:mm"
                        label="Fecha/Hora fin"
                        value={this.state.filtroFechaFin}
                        onChange={date => this.fechaFiltroChanged('fin', date)}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

                <Grid item container spacing={2}>
                  <Grid item>
                    <FormControl>
                      <InputLabel>Evento</InputLabel>
                      <Select
                        style={{ width: 200 }}
                        label="Evento"
                        inputRef={this.cmbEstados}
                        defaultValue={0}
                      >
                        <MenuItem value={0}>-- Todos los eventos --</MenuItem>
                        {this.state.acciones.map(accion => (
                          <MenuItem key={accion.id} value={accion.id}>
                            {accion.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item>
                    <FormControl>
                      <InputLabel>Cajero</InputLabel>
                      <Select
                        style={{ width: 200 }}
                        label="Cajero"
                        inputRef={this.cmbCajeros}
                        defaultValue={0}
                      >
                        <MenuItem value={0}>-- Seleccione --</MenuItem>
                        {this.state.cajeros.map(cajero => (
                          <MenuItem key={cajero.id} value={cajero.id}>
                            {cajero.alias}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>

            <CardActions>
              <Button variant="contained" onClick={this.btnBucarClick}>Buscar</Button>
              <Snackbar
                open={this.state.mostrarAlerta}
                onClose={this.handleCloseAlert}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Collapse in={this.state.mostrarAlerta}>
                  <Alert
                    severity={this.state.severidadAlerta}
                    onClose={this.handleCloseAlert}
                    sx={{ marginTop: 4, width: '100%' }}
                  >
                    <AlertTitle>{this.state.severidadAlerta.toUpperCase()}</AlertTitle>
                    {this.state.mensajeAlerta}
                  </Alert>
                </Collapse>
              </Snackbar>
            </CardActions>
          </Card>
        </Paper>

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />

        <Paper elevation={16}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h6">
                Historico de Eventos
              </Typography>

              <Divider style={{ marginTop: 10, marginBottom: 10 }} />

              {this.state.timeline.length > 0 &&
                <Button
                  style={{ marginTop: 10, marginBottom: 10 }}
                  variant='contained'
                  onClick={this.exportExcel}
                >
                  Exportar
                </Button>
              }

              <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
                mb: 3
              }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{
                      '& th': {
                        backgroundColor: 'primary.main',
                        color: 'primary.contrastText',
                        fontWeight: 'fontWeightBold',
                        fontSize: '0.8rem',
                        py: 1.5,
                        px: 2
                      }
                    }}>
                      <TableCell>Fecha</TableCell>
                      <TableCell>Tipo</TableCell>
                      <TableCell>Evento</TableCell>
                      <TableCell>Cajero</TableCell>
                      <TableCell>Funcionario</TableCell>
                      <TableCell>Usuario autorizó</TableCell>
                      <TableCell>Detalle</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {this.state.timeline.map((row, idx) => (
                      <TableRow
                        key={idx}
                        sx={{
                          backgroundColor: row.tipo_origen === 'SERVIDOR' ? '#E3F2FD' : '#E8F5E9'
                        }}
                      >
                        <TableCell>{row.fecha}</TableCell>
                        <TableCell>{row.tipo_origen}</TableCell>
                        <TableCell>{row.nombre_evento}</TableCell>
                        <TableCell>{row.cajero}</TableCell>
                        <TableCell>{row.funcionario  || '—'}</TableCell>
                        <TableCell>{row.usuario_autorizo || '—'}</TableCell>
                        <TableCell>{row.detalle || '—'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </CardContent>
          </Card>
        </Paper>
      </Box>
    )
  }
}
export default EventosCajeroPage